module.exports = __webpack_public_path__ + "static/img/noaward-bg.1786686659715.png";